import React from 'react';

export const AutoBetContent = ({ autoBetState, setAutoBetState }) => {
  return (
    <div className='r-auto-bet-inner-content'>
      <div className='r-a-p-content-inner'>
        <div className='r-a-p-info'>
          <div className='r-auto-bet'>
            <div className='r-auto-bet-row-line'>
              <span
                className={`r-auto-bet-num ${autoBetState === 5 ? 'selected active' : ''}`}
                data-value='5'
                onClick={() => setAutoBetState(5)}
              />
              <span
                className={`r-auto-bet-num ${autoBetState === 10 ? 'selected active' : ''}`}
                data-value='10'
                onClick={() => setAutoBetState(10)}
              />
              <span
                className={`r-auto-bet-num ${autoBetState === 25 ? 'selected active' : ''}`}
                data-value='25'
                onClick={() => setAutoBetState(25)}
              />
              <span
                className={`r-auto-bet-num ${autoBetState === 50 ? 'selected active' : ''}`}
                data-value='50'
                onClick={() => setAutoBetState(50)}
              />
              <span
                className={`r-auto-bet-num ${autoBetState === 100 ? 'selected active' : ''}`}
                data-value='100'
                onClick={() => setAutoBetState(100)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
